import timotej from "./timotej.avif"
import laura from "./laura.avif"
import an from "./an.avif"
import vid from "./vid.avif"
import patricija from "./patricija.avif"
import nusa from "./nusaDolinsek.png"


export const oNasPodatki = [
    {
        ime: "Timotej Willewaldt",
        opis: "Ustanovitelj, vodja organizacije, violinist",
        slika: timotej,
        facebook: "https://www.facebook.com/timotej.willewaldt.3",
        instagram: "https://www.instagram.com/t.willewaldt",
    },
    {
        ime: "Laura de Wolff",
        opis: "Soorganizatorka, violinistka",
        slika: laura,
        facebook: "https://www.facebook.com/laura.dewolff.98",
        instagram: "https://www.instagram.com/wolff.de/",
    },
    {
        ime: "An Černe",
        opis: "Soorganizator Glasbe mladih,  idejni vodja projekta Zgodbe starega sveta, flavtist",
        slika: an,
        facebook: "https://www.facebook.com/profile.php?id=100017565228340",
        instagram: "https://www.instagram.com/an_cerne/",
    },
    {
        ime: "Vid Ibic",
        opis: "Soorganizator, pianist, študent medicine",
        slika: vid,
        facebook: "https://www.facebook.com/vid.ibic",
        instagram: "https://www.instagram.com/vid_ibic/",
    },
    {
        ime: "Patricija Malovrh Mlačnik",
        opis: "Soorganizatorka, violistka",
        slika: patricija,
        facebook: "https://www.facebook.com/patricija.malovrhmlacnik",
        instagram: "https://www.instagram.com/patricijammlacnik/",
    },
    {
        ime: "Nuša Dolinšek",
        opis: "Soorganizatorka, flavtistka",
        slika: nusa,
        facebook: "https://www.facebook.com/nusa.dolinsek.3",
        instagram: "https://www.instagram.com/nusadolinsek/",
    },
];
